<template>
    <aside
        v-if="env.DEV"
        :class="[
            'absolute flex items-center gap-2',
            'bottom-14 left-14 z-50',
            'text-xs text-surface-400',
            'h-0 w-0 overflow-hidden opacity-0',
        ]"
    >
        <Button
            data-testid="reset-e2e-data-button"
            variant="link"
            size="small"
            icon="pi pi-icon pi-trash"
            @click="resetData()"
            class="rounded-full bg-danger p-2 text-surface-0 hover:bg-danger-700"
        />
        <section class="text-xs">
            <p>Reset Data (E2E)</p>
            <p>Dev Only!</p>
        </section>
    </aside>
</template>

<script setup lang="ts">
    import { useE2EResetData } from '@/api/e2e';
    import { getEnv } from '@/utils/envUtils';

    const { mutate: resetData } = useE2EResetData();

    const env = getEnv();
</script>
